import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { PlanPolicyDetailCard } from '@pumpkincare/shared';
import { TIER_MAP } from '@pumpkincare/wellness';

import { parseAndFormatDate } from '../../../shared/utils';
import { wellnessRenewalChangeStyle } from './wellness-renewal-change-style';

function getWellnessDates(wellness) {
  const wellnessStartDate = wellness?.start_date
    ? parseAndFormatDate(wellness?.start_date)
    : 'N/A';
  const wellnessEndDate = wellness?.end_date
    ? parseAndFormatDate(wellness?.end_date)
    : 'N/A';
  return `Plan Effective Dates: ${wellnessStartDate} - ${wellnessEndDate}`;
}

function WellnessRenewalChange({
  petData = {},
  tierOptions = [],
  onTierChange = () => {},
  changeSelectedData = '',
}) {
  const classes = wellnessRenewalChangeStyle();

  const wellnessDates = getWellnessDates(
    petData.wellness_plans.find(plan => plan.status === 'renew_pending')
  );

  return (
    <div>
      <Typography className={classes.ratesLabel}>Policy & Plan Term:</Typography>
      <div className={classes.detailCardDiv}>
        <PlanPolicyDetailCard
          title={`Pumpkin Wellness Club`}
          status={'renew_pending'}
          effectiveDatePeriod={wellnessDates}
          enrollmentDate={parseAndFormatDate(petData.wellness_plans[0].start_date)}
          coverageStartDate={parseAndFormatDate(
            petData.wellness_plans.find(plan => plan.status === 'renew_pending')
              ?.start_date
          )}
        />
      </div>

      <Typography className={classes.ratesLabel}>Plans</Typography>
      <FormControl sx={{ width: '100%' }} component='fieldset'>
        <div>
          <RadioGroup
            name='response-type'
            style={{ color: '#007DFF' }}
            value={changeSelectedData}
            onChange={event => {
              onTierChange(event.target.value);
            }}
          >
            {tierOptions.map(plan => (
              <div className={classes.radioGroupdDiv} key={plan.tier}>
                <Typography className={classes.tier}>
                  {TIER_MAP[plan.tier]}
                </Typography>
                <FormControlLabel
                  key={`tier-${plan.tier}`}
                  value={plan.tier}
                  data-testid={`radio-${plan.tier}`}
                  sx={{
                    '.MuiFormControlLabel-label': {
                      color: '#000000',
                      fontWeight: 700,
                    },
                  }}
                  control={
                    <Radio
                      sx={{
                        color: '#000000',
                      }}
                    />
                  }
                  label={`$${plan.price}`}
                />
              </div>
            ))}
          </RadioGroup>
        </div>
      </FormControl>
    </div>
  );
}

WellnessRenewalChange.propTypes = {
  petData: PropTypes.shape({
    wellness: PropTypes.object,
    wellness_plans: PropTypes.array,
    id: PropTypes.string,
    name: PropTypes.string,
    species: PropTypes.string,
    breed: PropTypes.string,
    state: PropTypes.string,
  }),
  tierOptions: PropTypes.arrayOf(
    PropTypes.shape({
      price: PropTypes.string.isRequired,
      tier: PropTypes.string.isRequired,
    })
  ),
  onTierChange: PropTypes.func,
  changeSelectedData: PropTypes.string,
};

export default WellnessRenewalChange;
